import page from 'page';

const Emitter = require('tiny-emitter');

const mediator = require('tiny-emitter/instance');

var emitter = new Emitter();
var readyEvent;
var root;
var basePath;
var current;
var prev;
var routes;
var defaultRoute;
var prevParams = {};

function start() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  basePath = options.basePath || '/';
  root = options.root || document.body;
  routes = options.routes;
  defaultRoute = options.default;
  readyEvent = options.readyEvent || 'ready';
  page(basePath + ':route', onRoute);
  page(basePath + ':route/:subroute', onRoute);
  page(basePath + '*', onRoute);
  page();
}

function onRoute(context) {
  let id = routes[context.params.route] ? context.params.route : defaultRoute;
  let ViewClass = routes[id];
  if (typeof context.params[0] == 'string' && context.params[0] == prevParams[0]) return;
  if (context.params.route && context.params.route == prevParams.route && context.params.subroute == prevParams.subroute) return;
  prev = current;
  current = new ViewClass({
    route: {
      current: context.params,
      prev: prevParams
    },
    autoEnter: false
  });
  root.appendChild(current);

  async function transition() {
    current.removeEventListener(readyEvent, transition);
    emitter.emit('route', id, context.params);
    mediator.emit('route', id, context.params);
    if (prev) await prev.leave({
      current: context.params,
      prev: prevParams
    });
    await current.enter({
      current: context.params,
      prev: prevParams
    });
    prevParams = JSON.parse(JSON.stringify(context.params));
  }

  current.addEventListener(readyEvent, transition);
}

export default {
  start,
  readyEvent,
  on: emitter.on.bind(emitter),
  off: emitter.off.bind(emitter),
  once: emitter.once.bind(emitter)
};